'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdHighlight = function MdHighlight(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.3 10.9l3.5-3.5 2.3 2.4-3.5 3.6z m-22.4-1.1l2.3-2.4 3.5 3.5-2.3 2.5z m12.5-6.4h3.2v5h-3.2v-5z m-8.4 20v-8.4h20v8.4l-5 5v8.2h-10v-8.2z' })
        )
    );
};

exports.default = MdHighlight;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/highlight.js
// module id = 2420
// module chunks = 0